<template>
  <div class="text-center" fill-height fluid>
    <v-dialog v-model="dialog" width="750">
      <template v-slot:activator="{}"></template>

      <template v-if="isSimpatika">
        <v-card
          class="text-center"
        >
          <v-toolbar flat>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pa-2 black--text">
            <div class="center" align="center" justify="center">
              <v-img :src="`https://cdn.siap.id/s3/masook/asset%20img/SIM/versi-aplikasi.png`" style="width: 200px"></v-img>
            </div>
            <div class="text-center pa-4 mx-5">
              <h2>Informasi Layanan</h2>
              <div class="mx-5 mt-2">
                Anda saat ini sedang menggunakan aplikasi MASOOK <span class="red--text">versi gratis</span>,
                sehingga akan banyak fitur kami yang masih belum bisa digunakan. Silakan berlangganan aplikasi untuk dapat menggunakan semua fitur
              </div>
            </div>
            <div class="mt-3 py-5 text-center">
              <v-btn dark depressed color="amber darken-3" @click="toBilling">Berlangganan</v-btn>
              <v-btn class="mx-2" depressed color="success" @click="dialog = false">Saya Mengerti</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </template>
      <template v-else>
        <v-card
          class="text-center rounded-lg"
          v-if="current_organisasi && current_organisasi.kuota_plotting"
        >
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="center" align="center" justify="center">
            <v-img
              style=" width : 150px"
              src="https://cdn.siap.id/s3/masook/asset%20img/SIM/info.png"
            ></v-img>
          </div>
          <p class="title mt-5">
            Perhatian !
          </p>
          <v-card-text class="" v-if="current_organisasi">
            <p
              class="text-center black--text mb-0"
              v-if="current_organisasi.is_normalisasi_kuota"
            >
              Terima kasih telah menggunakan layanan Masook,saat ini instansi Anda
              terdeteksi memiliki
              <strong
              >kelebihan pengguna
                {{
                  current_organisasi.jml_user - current_organisasi.kuota
                }}</strong
              >
              dari total kuota berlangganan {{ current_organisasi.kuota }}. Segera
              lakukan penambahan kuota atau non aktifkan pengguna Anda sampai
              batas maksimal kuota berlangganan Anda<br />
              <strong>
                sebelum tanggal {{ pVal(current_organisasi, "batas_normalisasi") | toSD }}.
              </strong>
              <br/><br/>
              Jika tidak dilakukan penambahan kuota atau non aktifkan pengguna hingga tanggal tersebut.
              Maka semua pengguna akan <b>DINONAKTIFKAN</b>. Dan silakan memilih pengguna yang diaktifkan, sejumlah kuota saja
            </p>
            <p class="text-center black--text mb-0" v-else>
            <span v-if="current_organisasi.kuota_plotting">
              Proses perpanjangan/berlangganan telah dilakukan kembali sejumlah
              {{ current_organisasi.kuota_plotting.kuota }} kuota untuk
              <strong>{{ current_organisasi.nama }}</strong
              >. Agar dapat melakukan presensi secara normal silakan pilih
              <strong> Anggota yang akan diaktifkan </strong> terlebih dahulu
              sebelum {{ current_organisasi.kuota_plotting.start_at | toDT }}.
              karena jumlah Anggota Anda lebih banyak dibandingkan kuota yang
              tersedia
              <br/><br/>
              Jika tidak dilakukan penambahan kuota atau non aktifkan pengguna hingga tanggal tersebut.
              Maka semua pengguna akan <b>DINONAKTIFKAN</b>. Dan silakan memilih pengguna yang diaktifkan, sejumlah kuota saja
            </span>
            </p>
            <div
              class="text-center pt-4"
              v-if="!current_organisasi.is_normalisasi_kuota"
            >
              <m-button
                class="a-2"
                text="Atur Sekarang"
                :large="false"
                color="primary"
                action="close"
                @close="toPlotting"
              ></m-button>
            </div>
          </v-card-text>
          <v-card-actions v-if="current_organisasi.is_normalisasi_kuota">
            <m-button
              outlined
              class="ma-2"
              text="Atur Sekarang"
              :large="false"
              color="primary"
              action="close"
              @close="toPlotting"
            ></m-button>
            <v-spacer></v-spacer>
            <m-button
              class="ma-2"
              text="Tambah Kuota"
              :large="false"
              color="primary"
              action="close"
              @close="toPembayaran"
            ></m-button>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <VPlotting ref="dlg" />
  </div>
</template>

<script>
import VPlotting from "../../user/components/FormPlotting";

export default {
  components: {
    VPlotting
  },
  data() {
    return {
      dialog: false,
      isOpen: false,
    };
  },

  created() {
    this.initPopup()
  },

  computed: {
    isSimpatika() {
      return this.current_organisasi && this.current_organisasi.k_sumber_data === 1
    },

    // dialog: {
    //   get: function () {
    //
    //   },
    //   set: function (newValue) {
    //     return newValue;
    //   }
      // if(this.current_organisasi){
      //   // @vuese
      //   // menampilkan notifikasi plotting jika is_plotting_kuota true (kuota renewal lebih kecil dari jumlah aktif)
      //   // menampilkan notifikasi plotting jika is_plotting_kuota true (kuota renewal lebih kecil dari jumlah aktif)
      //   // dan belum melakukan plotting
      //   if (
      //     this.current_organisasi &&
      //     !this.$store.getters["main/berlangganan"] &&
      //     this.current_organisasi.is_normalisasi_kuota &&
      //     this.$route.name !== "organisasi.pilih"
      //   ) {
      //     return true
      //   } else if (
      //     isCan("organisasi.update") &&
      //     this.current_organisasi &&
      //     !this.$store.getters["main/berlangganan"] &&
      //     this.current_organisasi.is_plotting_kuota &&
      //     this.current_organisasi.is_user_plot &&
      //     this.$route.name !== "organisasi.pilih"
      //   ) {
      //     return true
      //   }else{
      //     return false
      //   }
      // }
      // get: function() {
      //
      //   if(this.current_organisasi){
      //     // @vuese
      //     // menampilkan notifikasi plotting jika is_plotting_kuota true (kuota renewal lebih kecil dari jumlah aktif)
      //     // dan belum melakukan plotting
      //     if (
      //       this.current_organisasi &&
      //       !this.$store.getters["main/berlangganan"] &&
      //       this.current_organisasi.is_normalisasi_kuota &&
      //       this.$route.name !== "organisasi.pilih"
      //     ) {
      //       return true
      //     } else if (
      //       isCan("organisasi.update") &&
      //       this.current_organisasi &&
      //       !this.$store.getters["main/berlangganan"] &&
      //       this.current_organisasi.is_plotting_kuota &&
      //       this.current_organisasi.is_user_plot &&
      //       this.$route.name !== "organisasi.pilih"
      //     ) {
      //       return true
      //     }else{
      //       return false
      //     }
      //   }
      //
      // },
      // set: function(newValue) {
      //   return newValue;
      // }
      // }
    // }
  },

  methods: {
    open() {},

    close() {
      this.dialog = false
    },

    // eslint-disable-next-line
    toPlotting() {
      if (this.current_organisasi.is_normalisasi_kuota) {
        this.dialog = false;
        this.$router.push({
          name: "user",
          params: {
            organisasi_id: this.organisasi_id
          }
        });
      } else {
        this.dialog = false;
        this.$refs.dlg.open().then(() => {
          this.isOpen = false;
        });
      }
    },

    toBilling() {
      this.dialog = false;
      const url = this.is_develop ? 'https://dev.masook.id/#/simpatika/order' : 'https://masook.id/simpatika'
      window.open(url, '_blank')
    },

    toPembayaran() {
      this.dialog = false;
      if (this.$route.name !== "billing") {
        this.$router.push({
          name: "billing",
          params: {
            organisasi_id: this.organisasi_id,
            tipe: 3,
            auto: true
          }
        });
      }
    },

    initPopup() {
      if (this.current_organisasi) {
        if (this.isOpen && this.current_organisasi && this.current_organisasi.user.role == "Operator" && this.$route.name !== "organisasi.pilih") {
          // NORMALISASI
          if (this.current_organisasi.is_langganan && this.current_organisasi.is_normalisasi_kuota) {
            this.dialog = true
          } else if (this.current_organisasi.is_langganan && this.current_organisasi.is_plotting_kuota) {
            this.dialog = true
          }
        } else if (!this.current_organisasi.is_langganan && this.isSimpatika) {
          this.dialog = true
        }
      }
    }
  },
};
</script>
